export const TASK_STATUSES = [
  { value: "todo", label: "Pendiente", color: "#9AA0A6" },
  { value: "in_progress", label: "En progreso", color: "#1A73E8" },
  { value: "review", label: "En revisión", color: "#9D4CDD" },
  { value: "done", label: "Completada", color: "#1E8E3E" },
];

export const STATUS_MAP = Object.fromEntries(TASK_STATUSES.map((s) => [s.value, s]));

export const PRIORITIES = [
  { value: "lowest", label: "Muy baja", color: "#9AA0A6" },
  { value: "low", label: "Baja", color: "#26A69A" },
  { value: "medium", label: "Media", color: "#F9AB00" },
  { value: "high", label: "Alta", color: "#FF7043" },
  { value: "critical", label: "Crítica", color: "#D93025" },
];

export const PRIORITY_MAP = Object.fromEntries(PRIORITIES.map((p) => [p.value, p]));

export const PROJECT_STATUSES = [
  { value: "active", label: "Activo", color: "#1E8E3E" },
  { value: "paused", label: "En pausa", color: "#F9AB00" },
  { value: "completed", label: "Finalizado", color: "#1A73E8" },
  { value: "archived", label: "Archivado", color: "#9AA0A6" },
];

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const isOverdue = (t) => !!t.due_date && t.status !== "done" && t.due_date < todayStr();

export const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("es-ES", { day: "numeric", month: "short" });
};

export const parseDate = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const toISODate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const addDays = (iso, days) => {
  const d = parseDate(iso);
  d.setDate(d.getDate() + days);
  return toISODate(d);
};

export const daysBetween = (a, b) => Math.round((parseDate(b) - parseDate(a)) / 86400000);

export function applyTaskFilters(tasks, filters) {
  return tasks.filter((t) => {
    if (filters.q && !`${t.title} ${t.description}`.toLowerCase().includes(filters.q.toLowerCase())) return false;
    if (filters.assignee === "unassigned") {
      if (t.assignee_id) return false;
    } else if (filters.assignee !== "all" && t.assignee_id !== filters.assignee) return false;
    if (filters.status !== "all" && t.status !== filters.status) return false;
    if (filters.priority !== "all" && t.priority !== filters.priority) return false;
    if (filters.overdue && !isOverdue(t)) return false;
    return true;
  });
}

export const TASK_RECURRENCES = [
  { value: "none", label: "No se repite" },
  { value: "daily", label: "Diaria" },
  { value: "weekly", label: "Semanal" },
  { value: "biweekly", label: "Cada 2 semanas" },
  { value: "monthly", label: "Mensual" },
];
